export const ATTACKS = 1;
export const BREACHES = 0;
export const EMPTYMAP = "emptymap";
export const VIEWALLMAP = 2;
